/*
 * tol-helium-select-headings.js — Helium（customer-fields）の検索付きセレクト（お気に入り店舗）で、
 * 見出し用に挟んでいる「■北海道地方--------」などの行を選べなくする（2026-10）。
 * ------------------------------------------------------------------
 * ・Helium のドロップダウンの選択肢は全部ふつうの選択肢（button.cf-select-search-result）として描かれ、
 *   アプリ側に「見出し（選択不可）」の設定は無い。そこでテーマ側で、文字が「■…地方」で始まる行を見出しとみなし、
 *   ①見た目を見出しにする（class tol-cf-heading・CSS は tol-account-forms.css）
 *   ②押しても選ばれないようにする（Helium の処理より先に capture 段で止める）。
 * ・候補リストは開くたび・検索文字を打つたびに Helium が描き直すので、MutationObserver で付け直す。
 * ・押下を止めるのは mousedown / pointerdown / click / touchend（Helium がどの段で選ぶか公開されていないため全部）。
 *   touchstart は止めない（見出しの上から指でリストをスクロールできるように）。
 * ・キーボード（↑↓＋Enter）で見出しに合わせて Enter を押した場合は止められないことがある（Helium 内部の状態のため）。
 * ・見出しの判定条件は HEADING の 1 か所。運用で見出しの書き方を変えたらここを直す。
 * 読み込み: layout/theme.liquid の tol-account-forms.css と同じ条件（会員フォーム面と /tools/customr）。
 */
(function () {
  if (window.__tolHeliumHeadings) return;
  window.__tolHeliumHeadings = true;

  var HEADING = /^\s*■.*地方/;

  function isHeading(btn) {
    return !!btn && HEADING.test(btn.textContent || '');
  }

  function mark(root) {
    var list = (root || document).querySelectorAll('.cf-select-search-result');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (isHeading(b)) {
        if (!b.classList.contains('tol-cf-heading')) {
          b.classList.add('tol-cf-heading');
          b.setAttribute('aria-disabled', 'true');
          b.setAttribute('tabindex', '-1');
        }
      } else if (b.classList.contains('tol-cf-heading')) {
        /* 描き直しで同じ button が別の店舗名に使い回された場合に戻す */
        b.classList.remove('tol-cf-heading');
        b.removeAttribute('aria-disabled');
        b.removeAttribute('tabindex');
      }
    }
  }

  function block(e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('.cf-select-search-result') : null;
    if (!isHeading(btn)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
  ['mousedown', 'pointerdown', 'click', 'touchend'].forEach(function (type) {
    document.addEventListener(type, block, true);
  });

  function start() {
    mark(document);
    if (typeof MutationObserver === 'undefined') return;
    var timer = 0;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = 0;
        mark(document);
      }, 0);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();